import isEmail from 'validator/lib/isEmail';

const email = value => {
    if ( value == "" || value === null || typeof value === 'undefined') return undefined;
    return !isEmail(value + '') ? 'Please enter valid email': undefined;
} 
export default email;